import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddIcon from '@mui/icons-material/Add';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { Box, ClickAwayListener, Divider, Grid, IconButton, InputAdornment, Tab, Tooltip, Typography } from "@mui/material";
import { fileUrl } from 'api/api';
import TreatmentApi from 'api/dentists/treatment.api';
import TreatmentProductApi from 'api/dentists/treatmentProduct.api';
import ClinicApi, { BranchInterface } from 'api/master/clinic.api';
import ProductInstructionsApi from 'api/setting/default-products/product-instruction.api';
import ProductSymptomApi from 'api/setting/default-products/product-symptom';
import ProductTypesApi from 'api/setting/default-products/product-type.api';
import ProductUnitsApi from 'api/setting/default-products/product-unit.api';
import ProductUsesApi from 'api/setting/default-products/product-use.api';
import ProductWarningsApi from 'api/setting/default-products/product-warning.api';
import TemplateTypeApi from 'api/setting/treatment-templates/template-tpyes.api';
import TemplateApi from 'api/setting/treatment-templates/template.api';
import OperativeTypeApi from 'api/setting/treatments/operative-type.api';
import MedicinesApi from 'api/warehouses/medicine.api';
import { showModal } from 'app/slice/modal.slice';
import { selectMe } from 'app/slice/user.slice';
import { ButtonInfoSimple } from 'component/Button/ButtonInfo';
import HeaderLabel from "component/CardCustom/HeaderLabel";
import InputCheckbox from 'component/Input/InputCheckbox';
import InputTextField from 'component/Input/InputTextField';
import Loading from 'component/Loading';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import AutocompleteSelect from 'component/Select/AutocompleteSelect';
import TableCustom from "component/Table/TableCustom";
import TableRowCommon from 'component/Table/TableRowCommon';
import TableRowNonIcon from 'component/Table/TableRowNonIcon';
import { PopupManageProductAddForm } from 'component/Treatments/PopupManageProductAddForm';
import { icons, onImgError } from 'constants/images';
import { colors } from "constants/theme";
import { CustomFilterDoctor, ListFilterDoctors } from 'features/counter/appointment/head-appointment';
import { SpanClearFilter } from 'features/report/useStyled';
import * as UseStyled from 'features/setting/treatment-courses/treatment-course/style';
import * as UsedTxPlanStyled from 'features/setting/treatment-plans/treatment-plans/style';
import { ButtonType, InventoryChip, ProductBox, ProductCard, ProductItem, TypeTabs } from 'features/treatments/MainMenu/OPD/style/ProductUseStyle';
import { IconAddBox } from 'features/treatments/MainMenu/OPD/style/UseStyle';
import _, { debounce } from "lodash";
import CheckboxButton from 'new-components/buttons/checkbox-button';
import SelectInput from 'new-components/inputs/select-input';
import TextInput from "new-components/inputs/text-input";
import PageModal from 'new-components/modal/page-modal';
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { routeName } from "routes/routes-name";
import { getBranch, numberFormat, numberOnly, checkAddons } from 'utils/app.utils';
import { PACKAGE_ADDONS } from 'constants/package';

interface ProductObjType {
    id: number
    name: string
    nameEn?: string
}
interface SummaryTemplateListInterface {
    group?: 'TX' | 'MED' | 'PD'
    itemId: any
    itemCode: string
    itemName: string
    priceUnit: any
    amount: any
    itemSort?: number
}

const initStateErrorMessage = {
    TEMPLATE_NAME: '',
    TEMPLATE_NAME_EN: '',
    TEMPLATE_CODE: '',
    TEMPLATE_TYPE_ID: '',
    TREATMENT_LIST_AMOUNT: ''
}

export default function TreatmentTemplateForm() {
    const { t } = useTranslation()
    const location = useLocation()
    const user = useSelector(selectMe)
    const branchId = Number(getBranch())
    const history = useHistory()
    const dispatch = useDispatch()

    const tabs: string[] = ['DX', 'TX', 'MED', 'PD', 'MAT']
    const [activeTab, setActiveTab] = useState(1)
    const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(5)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createAt')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [summaryTemplateList, setSummaryTemplateList] = useState<any>([])
    const [summaryDiagnosisList, setSummaryDiagnosisList] = useState<any>([])

    const [templateName, setTemplateName] = useState('')
    const [templateNameEn, setTemplateNameEn] = useState('')
    const [templateCode, setTemplateCode] = useState('')
    const [templateDescription, setTemplateDescription] = useState('')

    const [pageDiagnosis, setPageDiagnosis] = useState(1)
    const [pageLimitDiagnosis, setPageLimitDiagnosis] = useState(5)
    const [rowCountDiagnosis, setRowCountDiagnosis] = useState(0)
    const [sortByDiagnosis, setSortByDiagnosis] = useState('createAt')
    const [sortTypeDiagnosis, setSortTypeDiagnosis] = useState('ASC')
    const [searchDiagnosis, setSearchDiagnosis] = useState('')

    const [dataEdit, setDataEdit] = useState<any>(null)
    const [operativeType, setOperativeType] = useState([])
    const [operatives, setOperatives] = useState([])
    const [templateTypeOption, setTemplateTypeOption] = useState<any>([])
    const [templateTypeId, setTemplateTypeId] = useState('')
    const [productTypes, setProductTypes] = useState([])
    const [allProduct, setAllProduct] = useState<any>([]);
    const [products, setProducts] = useState([])
    const [medicines, setMedicines] = useState([])
    const [materials, setMaterials] = useState([])
    const [diagnosisType, setDiagnosisType] = useState([])
    const [diagnosis, setDiagnosis] = useState([])
    const [searchProduct, setSearchProduct] = useState('')
    const [typeSelected, setTypeSelected] = useState<number | string>('ALL');
    const [selectFilterOperative, setSelectFilterOperative] = useState('ALL')
    const [selectFilterDiagnosis, setSelectFilterDiagnosis] = useState('ALL')

    const [loading, setLoading] = useState(false)
    const [isOpenModalMedicine, setIsOpenModalMedicine] = useState(false)
    const [dataLoading, setDataLoading] = useState(false)
    const [productInstructions, setProductInstructions] = useState<ProductObjType[]>([]);
    const [productUnits, setProductUnits] = useState<ProductObjType[]>([]);
    const [productUses, setProductUses] = useState<ProductObjType[]>([]);
    const [productSymptom, setProductSymptom] = useState<ProductObjType[]>([]);
    const [productWarning, setProductWarning] = useState<ProductObjType[]>([]);
    const [med, setMed] = useState<any>(null)

    const [typeAdd, setTypeAdd] = useState<'PRODUCT_SYMPTOM' | 'PRODUCT_USES' | 'PRODUCT_UNITS' | 'PRODUCT_INSTRUCTION'>('PRODUCT_INSTRUCTION')
    const [items, setItems] = useState<any>()
    const [maxLength, setMaxLength] = useState<number>(0);
    const [isShowAddProductChoice, setIsShowAddProductChoice] = useState<boolean>(false)
    const [openFilterBranch, setOpenFilterBranch] = useState(false)
    const [branches, setBranches] = useState<BranchInterface[]>([])
    const [selectBranch, setSelectBranch] = useState<any[]>([getBranch()])
    const [selectCheckbox, setSelectCheckbox] = useState(false)
    const [listCourseAmount, setListCourseAmount] = useState(false)
    const [modalTable, setModalTable] = useState(false)
    const loadBranch = async () => {
        await ClinicApi.findAllBranches().then(({ data }) => {
            setBranches(data)
        })
    }

    const handleChangeSelectBranch = (value: any) => {
        if ((value === 'ALL' && _.size(selectBranch.filter((item) => typeof item === 'number')) === _.size(branches)) || value === 'CLEAR') setSelectBranch([''])
        else if (value === 'ALL') setSelectBranch([..._.map(branches, (d: any) => d.branchId)])
        else if (_.includes(selectBranch, value)) setSelectBranch(_.filter(selectBranch, (d) => d !== value))
        else setSelectBranch([...selectBranch, value])
    }

    const loadDiagnosis = async (searches?: any, pages?: number, typeId?: any) => {
        let condition: any = {}
        condition = { ...condition, status: 'ACTIVE' }
        condition = { ...condition, page: pages || pageDiagnosis }
        condition = { ...condition, search: searches || searchDiagnosis }
        if (pageLimitDiagnosis) condition = { ...condition, pageLimit: pageLimitDiagnosis }
        // if (user.userId) condition = { ...condition, userId: user.userId }
        if (typeId) {
            if (typeId !== "ALL") condition = { ...condition, typeId: typeId }
        } else {
            if (selectFilterDiagnosis !== "ALL") condition = { ...condition, typeId: selectFilterDiagnosis }
        }
        await TreatmentApi.findAllDiagnosis(condition).then(({ headers, data }) => {
            setRowCountDiagnosis(headers['x-total'] || 0)
            setDiagnosis(data)
        })
    }

    useEffect(() => {
        loadDiagnosis()
    }, [pageLimitDiagnosis, diagnosisType, selectFilterDiagnosis])

    const debouncedLoadDiagnosis = useMemo(
        () =>
            debounce((value: string, page?: number, typeId?: any) => {
                loadDiagnosis(value, page || 1, typeId);
            }, 500),
        []
    );

    const loadOperative = async (searches?: any, pages?: number, typeId?: any) => {
        let condition: any = {}
        condition = { ...condition, status: 'ACTIVE' }
        condition = { ...condition, page: pages || page }
        condition = { ...condition, search: searches || search }
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
        if (typeId) {
            if (typeId !== "ALL") condition = { ...condition, typeId: typeId }
        } else {
            if (selectFilterOperative !== "ALL") condition = { ...condition, typeId: selectFilterOperative }
        }
        await TreatmentApi.findAllOperative(condition).then(({ headers, data }) => {
            const rawOperatives: any = []
            _.map(data, (opt, index) => {
                rawOperatives.push({
                    group: 'TX',
                    itemId: opt.operativeId,
                    type: opt.operativeTypeName,
                    itemName: opt.operativeName || opt.operativeNameEn,
                    itemTypeId: opt?.operativeTypeId,
                    itemCode: opt.operativeCode,
                    unit: opt.operativeUnitName || '-',
                    price: opt.price,
                    isPriceRange: opt.isPriceRange,
                    minSalePrice: opt.minSalePrice,
                    maxSalePrice: opt.maxSalePrice
                })
            })
            setOperatives(rawOperatives)
            setRowCount(headers['x-total'] || 0)
        })
    }

    useEffect(() => {
        loadOperative()
    }, [pageLimit, selectFilterOperative])

    const debouncedLoadOperative = useMemo(
        () =>
            debounce((value: string, page?: number, typeId?: any) => {
                loadOperative(value, page || 1, typeId);
            }, 500),
        []
    );

    const loadAllProduct = async () => {
        if (!productTypes.length) {
            const resTypes = await ProductTypesApi.findAll({ status: 'ACTIVE', pageLimit: 100 })
            setProductTypes(resTypes?.data || [])
        }
        let condition_P: any = { page: 1, pageLimit: 1000, branchId: branchId, userId: user.userId, group: 'PRODUCT' }
        if (typeSelected !== "ALL") condition_P = { ...condition_P, itemTypeId: typeSelected }
        let resProducts: any = [];
        const resPds = await TreatmentProductApi.findAllProduct(condition_P)
        resProducts = resPds.data || []

        let condition_M: any = { page: 1, pageLimit: 1000, branchId: branchId, userId: user.userId, group: 'MEDICINE' }
        if (typeSelected !== "ALL") condition_M = { ...condition_M, itemTypeId: typeSelected }
        const resMds = await TreatmentProductApi.findAllProduct(condition_M)
        resProducts = [...resProducts, ...(resMds.data || [])]

        let condition_Mat: any = { page: 1, pageLimit: 1000, branchId: branchId, userId: user.userId, group: 'MATERIAL' }
        if (typeSelected !== "ALL") condition_Mat = { ...condition_Mat, itemTypeId: typeSelected }
        const resMat = await TreatmentProductApi.findAllProduct(condition_Mat)
        resProducts = [...resProducts, ...(resMat.data || [])]

        setAllProduct(resProducts)
    }

    useEffect(() => {
        loadAllProduct()
    }, [typeSelected]);

    const loadProduct = async (search?: string, group?: any) => {
        await TreatmentProductApi.findAllProduct({ page: 1, pageLimit: 1000, branchId: branchId, userId: user?.userId, group: group, search: search }).then((resp) => {
            setAllProduct(resp.data)
        })
    }

    const debouncedLoadProduct = useMemo(
        () =>
            debounce((value: string, group: any) => {
                loadProduct(value, group);
            }, 500),
        []
    );

    const loadTemplateType = async () => {
        const resp: any = await TemplateTypeApi.findAll({ page: 1, pageLimit: 1000, status: "ACTIVE" })
        if (resp.status === 200) {
            setTemplateTypeOption(resp.data)
        } else {
            setTemplateTypeOption([])
        }
    }

    const loadOperativeType = async () => {
        await OperativeTypeApi.findAll({ status: 'ACTIVE', pageLimit: 50 }).then((resp) => {
            setOperativeType(resp.data)
        })

    }

    const loadDiagnosisType = async () => {
        await await TreatmentApi.findAllDiagnosisType().then(({ data }) => data && setDiagnosisType(data))
    }


    useEffect(() => {
        loadBranch()
        loadTemplateType()
        loadInstruction()
        loadUnit()
        loadUses()
        loadSymtom()
        loadWarning()
        loadOperativeType()
        loadDiagnosisType()
    }, []);

    const loadInstruction = async (search?: any) => {
        await ProductInstructionsApi.findAll({ status: 'ACTIVE', group: "MEDICINE", pageLimit: 50, search: search || '' })
            .then(({ data }) => {
                let newProductInstructions: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductInstructions = [...newProductInstructions, { id: i.productInstructionId, name: i.productInstructionName || i.productInstructionNameEn }]
                })
                setProductInstructions(newProductInstructions)
            }).catch(() => { return }).finally(() => { setDataLoading(false) })
    }

    const loadUnit = async (search?: any) => {
        await ProductUnitsApi.findAll({ status: 'ACTIVE', group: "MEDICINE", pageLimit: 50, search: search || '' })
            .then(({ data }) => {
                let newProductUnits: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductUnits = [...newProductUnits, { id: i.productUnitId, name: i.productUnitName, nameEn: i.productUnitNameEn }]
                })
                setProductUnits(newProductUnits)
            }).catch(() => { return }).finally(() => { setDataLoading(false) })
    }

    const loadUses = async (search?: any) => {
        await ProductUsesApi.findAll({ status: 'ACTIVE', group: "MEDICINE", pageLimit: 50, search: search || '' })
            .then(({ data }) => {
                let newProductUses: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductUses = [...newProductUses, { id: i.productUseId, name: i.productUseDetail }]
                })
                setProductUses(newProductUses)
            }).catch(() => { return }).finally(() => { setDataLoading(false) })
    }

    const loadSymtom = async (search?: any) => {
        await ProductSymptomApi.findAll({ status: 'ACTIVE', group: "MEDICINE", pageLimit: 50, search: search || '' })
            .then(({ data }) => {
                let newProductSymptom: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductSymptom = [...newProductSymptom, { id: i.productSymptomId, name: i.detail }]
                })
                setProductSymptom(newProductSymptom)
            }).catch(() => { return }).finally(() => { setDataLoading(false) })
    }

    const loadWarning = async (search?: any) => {
        await ProductWarningsApi.getProductWarning({ status: 'ACTIVE', group: "MEDICINE", pageLimit: 50, search: search || '' })
            .then(({ data }) => {
                let newProductWarning: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductWarning = [...newProductWarning, { id: i.productWarningId, name: i.productWarningName }]
                })
                setProductWarning(newProductWarning)
            }).catch(() => { return }).finally(() => { setDataLoading(false) })
    }

    const handleInputSearch = useCallback(
        _.debounce((type: 'productInstructions' | 'productUnits' | 'productUses' | 'productSymptom' | 'productWarning', search?: string) => {
            if (type === 'productInstructions') loadInstruction(search)
            if (type === 'productUnits') loadUnit(search)
            if (type === 'productUses') loadUses(search)
            if (type === 'productSymptom') loadSymtom(search)
            if (type === 'productWarning') loadWarning(search)
        }, 1000), []);

    const headCellsDiagnosis = [
        { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '120px' },
        { id: 'dxId', disablePadding: false, label: t('TREATMENTS_DX.TABLE.CELL.DX_ID'), width: '150px' },
        { id: 'diagnosis', disablePadding: false, label: t('TREATMENTS_DX.TABLE.CELL.DIAGNOSIS') },
        { id: 'action', disablePadding: false, label: t('TREATMENTS_DX.TABLE.CELL.ACTION') }
    ]
    const renderDataDiagnosis = (objData: any, index: number) => {
        const no = pageDiagnosis * pageLimitDiagnosis - pageLimitDiagnosis + index + 1
        const objRenderData = {
            key: objData?.diagnosisId,
            id: objData?.diagnosisId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: no },
                { option: 'TEXT', align: 'left', label: objData?.diagnosisCode },
                { option: 'TEXT', align: 'left', label: objData?.diagnosisName },
                {
                    option: 'ADD',
                    align: 'center',
                    label: 'action',
                    disabled: summaryDiagnosisList.some((item: any) => item.itemId === objData?.diagnosisId) || disabledIsEdit()

                }
            ]
        }
        return <TableRowNonIcon onadd={() => onAddDiagnosis(objData)} {...objRenderData} />
    }

    const headCells = [
        {
            id: 'no',
            disablePadding: false,
            label: t('TREATMENT_PLAN.FORM.LIST.TABLE.NO')
        },
        {
            id: 'itemCode',
            disablePadding: false,
            label: t('TREATMENT_PLAN.FORM.LIST.TABLE.CODE')
        },
        {
            id: 'type',
            disablePadding: false,
            label: t('TREATMENT_PLAN.FORM.LIST.TABLE.TYPE')
        },
        {
            id: 'productService',
            disablePadding: false,
            label: t('TREATMENT_PLAN.FORM.LIST.TABLE.ITEM')
        },
        {
            id: 'unit',
            disablePadding: false,
            label: t('TREATMENT_PLAN.FORM.LIST.TABLE.UNIT')
        },
        {
            id: 'price',
            disablePadding: false,
            label: t('TREATMENT_PLAN.FORM.LIST.TABLE.PRICE')
        },
        {
            id: 'action',
            disablePadding: false,
            label: t('TREATMENT_PLAN.FORM.LIST.TABLE.ACOINT')
        }
    ]

    const renderData = (objData: any, no: number) => {
        no = page * pageLimit - pageLimit + no + 1
        const { type, itemCode, itemName, unit, price, itemId, status } = objData
        const statusBtnActive = status === 'ACTIVE' ? true : false
        const statusBtnInActive = status === 'INACTIVE' ? true : false
        const objRenderData = {
            key: itemId,
            id: itemId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: no },
                { option: 'TEXT', align: 'left', label: itemCode },
                { option: 'TEXT', align: 'left', label: type },
                { option: 'TEXT', align: 'left', label: itemName },
                { option: 'TEXT', align: 'left', label: unit },
                { option: 'TEXT', align: 'right', label: checkAddons(PACKAGE_ADDONS.ADDON_PRICE_RANGE) && objData?.isPriceRange === '1' && objData?.minSalePrice && objData?.maxSalePrice ? `${numberFormat(objData.minSalePrice)} - ${numberFormat(objData.maxSalePrice)}` : numberFormat(price) },
                {
                    option: 'ADD',
                    align: 'center',
                    label: 'action',
                    disabled: disabledIsEdit(),
                    values: [
                        { option: 'STATUS_ACTIVE', label: t(`+`), disabled: statusBtnActive },
                        { option: 'STATUS_INACTIVE', label: t(`+`), disabled: statusBtnInActive }
                    ]
                }
            ]
        }
        return <TableRowNonIcon onadd={() => onAdd(objData)} {...objRenderData} />
    }

    const onAdd = (objData: any) => {
        const find = summaryTemplateList.findIndex(({ itemId, group }: any) => Number(itemId) === Number(objData.itemId) && group === objData.group)
        if (find >= 0) {
            const summaryTemplateListTemp: any = [...summaryTemplateList]
            if (!modalTable) {
                summaryTemplateListTemp[find].amount = Number(summaryTemplateListTemp[find].amount) + 1
            }
            if (objData?.group === 'MEDICINE') {
                summaryTemplateListTemp[find].dosage = objData?.dosage
                summaryTemplateListTemp[find].productInstructionId = objData?.productInstructionId
                summaryTemplateListTemp[find].productInstructionName = objData?.productInstructionName
                summaryTemplateListTemp[find].productUnitId = objData?.productUnitId
                summaryTemplateListTemp[find].productUnitName = objData?.productUnitName
                summaryTemplateListTemp[find].productUseId = objData?.productUseId
                summaryTemplateListTemp[find].productUseDetail = objData?.productUseDetail
                summaryTemplateListTemp[find].productSymptomId = objData?.productSymptomId
                summaryTemplateListTemp[find].productSymptomDetail = objData?.productSymptomDetail
                summaryTemplateListTemp[find].productWarningId = objData?.productWarningId
                summaryTemplateListTemp[find].productWarningDetail = objData?.productWarningDetail
            }
            setSummaryTemplateList(summaryTemplateListTemp)
        } else {
            if (objData?.group === 'MEDICINE') {
                setSummaryTemplateList([...summaryTemplateList,
                {
                    group: objData.group,
                    itemId: parseInt(objData.itemId),
                    itemCode: objData.itemCode,
                    itemTypeId: objData?.itemTypeId,
                    itemTypeName: objData?.type,
                    itemName: objData.itemName,
                    amount: 1,
                    type: objData?.type,
                    dosage: objData?.dosage || 1,
                    priceUnit: objData.price,
                    unit: objData.unit,
                    qty: objData?.qty,
                    productInstructionId: objData?.productInstructionId || 0,
                    productInstructionName: objData?.productInstructionId === 0 ? '' : objData?.productInstructionName || objData?.productInstruction?.productInstructionName || '',
                    productUnitId: objData?.productUnitId || 0,
                    productUnitName: objData?.productUnitId === 0 ? '' : objData?.productUnitName || objData?.productUnit?.productUnitName || '',
                    productUnitNameEn: objData?.productUnitNameEn || '',
                    productUseId: objData?.productUseId || 0,
                    productUseDetail: objData?.productUseId === 0 ? '' : objData?.productUseDetail || objData?.productUse?.productUseDetail || '',
                    productSymptomId: objData?.productSymptomId || 0,
                    productSymptomDetail: objData?.productSymptomDetail || '',
                    productWarningId: objData?.productWarningId || 0,
                    productWarningDetail: objData?.productWarningId === 0 ? '' : objData?.productWarningDetail || objData?.productWarning?.productWarningName || '',
                    image: objData?.image
                }
                ])
            } else {
                setSummaryTemplateList([...summaryTemplateList, { group: objData.group, itemTypeId: objData?.itemTypeId, itemId: parseInt(objData.itemId), itemCode: objData.itemCode, itemName: objData.itemName, amount: 1, priceUnit: objData.price, unit: objData.unit, type: objData?.type, image: objData?.img || objData?.image }])
            }

        }
        setIsOpenModalMedicine(false)
    }

    const reloadProduct = () => {
        loadInstruction()
        loadUnit()
        loadUses()
        loadSymtom()
        loadWarning()
    }

    const handleDiscard = async (labelId: any, id: any) => {
        if (labelId === 'productInstructionId') {
            await ProductInstructionsApi
                .remove(id)
                .then(({ data }) => {
                    reloadProduct()
                    const newMed = {
                        ...med,
                        productInstructionId: 0,
                        productInstructionName: ''
                    }
                    setMed(newMed)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productUnitId') {
            await ProductUnitsApi
                .remove(id)
                .then(() => {
                    reloadProduct()
                    const newMed = {
                        ...med,
                        productUnitId: 0,
                        productUnitName: '',
                        productUnitNameEn: '',
                    }
                    setMed(newMed)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productUseId') {
            await ProductUsesApi
                .remove(id)
                .then(() => {
                    reloadProduct()
                    const newMed = {
                        ...med,
                        productUseId: 0,
                        productUseDetail: ''
                    }
                    setMed(newMed)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productSymptomId') {
            await ProductSymptomApi
                .remove(id)
                .then(() => {
                    reloadProduct()
                    const newMed = {
                        ...med,
                        productSymptomId: 0,
                        productSymptomDetail: ''
                    }
                    setMed(newMed)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productWarningId') {
            ProductWarningsApi.deleteProductWarning(id)
                .then(() => {
                    reloadProduct()
                    const newMed = {
                        ...med,
                        productWarningId: 0,
                        productWarningDetail: ''
                    }
                    setMed(newMed)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }

    }

    const onAddDiagnosis = (objData: any) => {
        setSummaryDiagnosisList([...summaryDiagnosisList, { group: 'DIAGNOSIS', itemTypeId: objData?.diagnosisTypeId, itemName: objData?.diagnosisName, itemId: objData?.diagnosisId, itemCode: objData?.diagnosisCode, }])
    }

    useEffect(() => {
        const dataEdit = location.state
        if (location.state) {
            setDataEdit(dataEdit)
            ClinicApi.findAllBranches().then(({ data }) => {
                onEdit(dataEdit, data)
            })
        } else {
            setDataEdit(null)
            onEdit(null)
        }
    }, [location])

    const disabledIsEdit = () => {
        const isMain = dataEdit?.treatmentTemplateBranches.find((item: any) => item?.isMain === '1')
        if (isMain) {
            if (isMain?.branchId === getBranch()) {
                return false
            } else {
                return true
            }
        } else {
            return false
        }

    }


    const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
        setSearch('')
        setSearchDiagnosis('')
        setActiveTab(newValue)
        setSelectFilterOperative('ALL')
        setSelectFilterDiagnosis('ALL')
        setTypeSelected('ALL')
        setPage(1)
        if (newValue === 0) {
            loadDiagnosis()
        } else if (newValue === 1) {
            loadOperative()
        } else if (newValue > 1) {
            setSearchProduct('')
            loadProduct('', newValue === 2 ? 'MEDICINE' : newValue === 3 ? 'PRODUCT' : 'MATERIAL')
        }
    }

    const handleProductBorder = (id: any) => {
        let stausStyle = false
        for (const index in summaryTemplateList) {
            const item = summaryTemplateList[index]
            if (item?.itemId === id) {
                stausStyle = true
                break
            }
        }
        return stausStyle
    }

    const handleFilterProduct = (data: any, valueTypeSelected: number | string) => {
        const med: any = []
        const pd: any = []
        const mat: any = []
        if (!_.isEmpty(allProduct) && valueTypeSelected === 'ALL') {
            _.map(data, (item, index) => {
                if (item.group === 'MEDICINE') med.push({
                    group: item.group === 'PRODUCT' ? 'PD' : 'MED',
                    itemId: item.itemId,
                    type: item?.itemTypeName || '-',
                    itemName: item.itemName,
                    itemCode: item.itemCode,
                    unit: item?.itemUnitName,
                    price: item.price,
                    img: item?.image || '',
                    qty: item.qty,
                    minStock: item.minStock,
                    isPriceRange: item.isPriceRange,
                    minSalePrice: item.minSalePrice,
                    maxSalePrice: item.maxSalePrice
                })
                else if (item.group === 'PRODUCT') {
                    pd.push({
                        group: item.group === 'PRODUCT' ? 'PD' : 'MED',
                        itemId: item.itemId,
                        type: item?.itemTypeName || '-',
                        itemName: item.itemName,
                        itemCode: item.itemCode,
                        unit: item?.itemUnitName,
                        price: item.price,
                        img: item?.image || '',
                        qty: item.qty,
                        minStock: item.minStock,
                        isPriceRange: item.isPriceRange,
                        minSalePrice: item.minSalePrice,
                        maxSalePrice: item.maxSalePrice
                    })
                } else {
                    mat.push({
                        group: 'MAT',
                        itemId: item.itemId,
                        type: item?.itemTypeName || '-',
                        itemName: item.itemName,
                        itemCode: item.itemCode,
                        unit: item?.itemUnitName,
                        price: item.price,
                        img: item?.image || '',
                        qty: item.qty,
                        minStock: item.minStock,
                        isPriceRange: item.isPriceRange,
                        minSalePrice: item.minSalePrice,
                        maxSalePrice: item.maxSalePrice
                    })
                }
            })
        } else if (!_.isEmpty(allProduct)) {
            _.map(data, (item, index) => {
                if (item.itemTypeId === valueTypeSelected) {
                    if (item.group === 'MEDICINE') med.push({
                        group: item.group === 'PRODUCT' ? 'PD' : 'MED',
                        itemId: item.itemId,
                        type: item?.itemTypeName || '-',
                        itemName: item.itemName,
                        itemCode: item.itemCode,
                        unit: item?.itemUnitName,
                        price: item.price,
                        img: item?.image || '',
                        qty: item.qty,
                        minStock: item.minStock,
                        isPriceRange: item.isPriceRange,
                        minSalePrice: item.minSalePrice,
                        maxSalePrice: item.maxSalePrice
                    })
                    else if (item.group === 'PRODUCT') {
                        pd.push({
                            group: item.group === 'PRODUCT' ? 'PD' : 'MED',
                            itemId: item.itemId,
                            type: item?.itemTypeName || '-',
                            itemName: item.itemName,
                            itemCode: item.itemCode,
                            unit: item?.itemUnitName,
                            price: item.price,
                            img: item?.image || '',
                            qty: item.qty,
                            minStock: item.minStock,
                            isPriceRange: item.isPriceRange,
                            minSalePrice: item.minSalePrice,
                            maxSalePrice: item.maxSalePrice
                        })
                    } else {
                        mat.push({
                            group: 'MAT',
                            itemId: item.itemId,
                            type: item?.itemTypeName || '-',
                            itemName: item.itemName,
                            itemCode: item.itemCode,
                            unit: item?.itemUnitName,
                            price: item.price,
                            img: item?.image || '',
                            qty: item.qty,
                            minStock: item.minStock,
                            isPriceRange: item.isPriceRange,
                            minSalePrice: item.minSalePrice,
                            maxSalePrice: item.maxSalePrice
                        })
                    }
                }
            })
        }
        setMedicines(med)
        setProducts(pd)
        setMaterials(mat)
    }

    useEffect(() => {
        handleFilterProduct(allProduct, typeSelected)
    }, [allProduct]);

    const renderImage = (image: any) => {
        if (image?.filePath && image?.fileName) return `${fileUrl}/${image.filePath}/${image.fileName}`
        else return activeTab === 2 ? icons.medDefault : activeTab === 3 ? icons.prodDefault : icons.matDefault
    }

    const handleChangeAmount = (count: string, index: number) => {
        const summaryTemplateListTemp: SummaryTemplateListInterface[] = [...summaryTemplateList]
        summaryTemplateListTemp[index].amount = count
        setSummaryTemplateList(summaryTemplateListTemp)
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => {
        setPage(val)
        debouncedLoadOperative(search, val, selectFilterOperative)
    }

    const handleChangeRowsPerPage = (limit: number) => {
        setPageLimit(limit)
    }

    const onEdit = async (data: any, branches?: any) => {
        if (data?.treatmentTemplateId) {
            await TemplateApi.findById(data?.treatmentTemplateId).then(async (resp) => {
                const diagnosisList = _.filter(resp.data?.treatmentTemplateItems, (item) => item?.type === "DIAGNOSIS")
                // const templateList = resp.data?.treatmentTemplateItems
                //     ?.filter((item) => item?.type !== "DIAGNOSIS")
                //     .map(({ qty, itemUnitName, price, type, itemTypeName, itemInfo, ...rest }) => {
                //         let productList: any[] = [];

                //         // ถ้าเป็น MEDICINE และมี itemInfo
                //         if (type === "MEDICINE" && itemInfo) {
                //             try {
                //                 const parsed = JSON.parse(itemInfo);
                //                 const medicines = Array.isArray(parsed) ? parsed : [parsed];

                //                 productList = medicines.map(med => ({
                //                     productInstructionId: med.productInstructionId ?? 0,
                //                     productInstructionName: med.productInstructionName ?? "",
                //                     productUnitId: med.productUnitId ?? 0,
                //                     productUnitName: med.productUnitName ?? "",
                //                     productUseId: med.productUseId ?? 0,
                //                     productUseDetail: med.productUseDetail ?? "",
                //                     productWarningId: med.productWarningId ?? 0,
                //                     productWarningDetail: med.productWarningDetail ?? "",
                //                     productSymptomId: med.productSymptomId ?? 0,
                //                     productSymptomDetail: med.productSymptomDetail ?? "",
                //                     amount: med.amount ?? 1,
                //                     priceUnit: med.priceUnit ?? 0,
                //                     unit: med.unit ?? "-"
                //                 }));
                //             } catch (err) {
                //                 console.warn("Error parsing itemInfo:", err);
                //             }
                //         }

                //         return {
                //             ...rest,
                //             amount: qty,
                //             unit: itemUnitName,
                //             priceUnit: price || 0,
                //             group: type === "OPERATIVE" ? "TX" : type,
                //             type: itemTypeName,
                //             ...(productList.length > 0 ? { productList } : {})
                //         };
                //     });
                const templateList = _.filter(
                    resp.data?.treatmentTemplateItems,
                    (item) => item?.type !== "DIAGNOSIS"
                ).map(({ qty, itemUnitName, price, type, itemTypeName, itemInfo, ...rest }, index) => {
                    let productData: any = {};
                    if (itemInfo) {
                        try {
                            const parsed = JSON.parse(itemInfo);
                            productData = parsed
                        } catch (err) {
                            console.warn("Error parsing itemInfo:", err);
                        }
                    }
                    // ✅ รวมข้อมูลทั้งหมดกลับ
                    return {
                        ...rest,
                        ...productData, // hardcode keys ที่เลือกแล้วเท่านั้น
                        amount: qty,
                        unit: itemUnitName,
                        priceUnit: price || 0,
                        group: type === "OPERATIVE" ? "TX" : type,
                        itemInfo: JSON.stringify(productData),
                        type: itemTypeName,
                    };
                });
                const branchIds = resp.data?.treatmentTemplateBranches.map((b: any) => b.branchId);
                const matchedBranchIds = branches
                    .filter((branch: any) => branchIds.includes(branch.branchId))
                    .map((branch: any) => branch.branchId);
                setSelectBranch(matchedBranchIds)
                setSelectCheckbox(resp.data?.treatmentTemplateBranches?.length > 1)
                setTemplateName(resp.data?.treatmentTemplateName)
                setTemplateNameEn(resp.data?.treatmentTemplateNameEn)
                setTemplateCode(resp.data?.treatmentTemplateCode)
                setTemplateTypeId(resp.data?.treatmentTemplateTypeId)
                setTemplateDescription(resp.data?.detail)
                setSummaryDiagnosisList(diagnosisList)
                setSummaryTemplateList(templateList)
            }).catch(() => notiError(t('ERROR')))
        }
        return
    }

    const onSubmit = async () => {
        if (!templateName || !templateNameEn || !templateCode || !templateTypeId) {
            setErrorMessage({
                ...errorMessage,
                TEMPLATE_NAME: !templateName ? 'กรุณากรอกชื่อเทมเพลต' : '',
                TEMPLATE_NAME_EN: !templateNameEn ? 'กรุณากรอกชื่อเทมเพลต(ภาษาอังกฤษ)' : '',
                TEMPLATE_CODE: !templateCode ? 'กรุณากรอกรหัสเทมเพลต' : '',
                TEMPLATE_TYPE_ID: !templateTypeId ? 'กรุณากรอกประเภทเทมเพลต' : ''
            })
            return
        }

        if (summaryDiagnosisList.length === 0 && summaryTemplateList.length === 0) {
            notiError('กรุณาเลือกรายการเทมเพลตหรือคำวินิจฉัย')
            return
        }

        if (selectCheckbox && selectBranch.length === 0) {
            notiError('กรุณาเลือกสาขา')
            return
        }

        if (selectCheckbox && selectBranch.length <= 1) {
            notiError('กรุณาเลือกสาขามากกว่า1สาขา')
            return
        }

        const amount = summaryTemplateList?.some((item: any) => !item?.amount)
        if (amount) {
            setListCourseAmount(true)
            return setErrorMessage({ ...errorMessage, TREATMENT_LIST_AMOUNT: amount ? 'กรุณากรอกจำนวน' : '' })
        }

        const treatmentTemplateItems: any = []
        summaryDiagnosisList.map((item: any) => (
            treatmentTemplateItems.push({
                type: 'DIAGNOSIS',
                itemTypeId: item?.itemTypeId,
                itemName: item?.itemName,
                itemId: item?.itemId,
                itemCode: item?.itemCode,
                qty: 1
            })
        ))
        summaryTemplateList.map((item: any) => (
            treatmentTemplateItems.push({
                type: item.group === 'TX' ? "OPERATIVE" : (item.group === 'MED' || item.group === 'MEDICINE') ? "MEDICINE" : (item.group === "PD" || item.group === 'PRODUCT') ? "PRODUCT" : "MATERIAL",
                itemTypeId: item?.itemTypeId,
                itemTypeName: item?.type,
                itemCode: item?.itemCode,
                itemId: item?.itemId,
                itemInfo: (item.group !== 'TX' || item.group !== "OPERATIVE") ? JSON.stringify(_.find(summaryTemplateList, (data) => data?.itemId === item?.itemId)) : '',
                itemName: item?.itemName,
                qty: item?.amount,
                itemUnitName: item?.unit,
            })
        ))

        const resultData = {
            treatmentTemplateName: templateName,
            treatmentTemplateNameEn: templateNameEn,
            treatmentTemplateCode: templateCode,
            treatmentTemplateTypeId: templateTypeId,
            treatmentTemplateItems: treatmentTemplateItems,
            detail: templateDescription,
            treatmentTemplateBranches: selectBranch
        }

        if (dataEdit?.treatmentTemplateId) {
            await TemplateApi.update(dataEdit?.treatmentTemplateId, resultData).then((resp) => {
                if (resp.data) {
                    notiSuccess(`แก้ไขเทมเพลตสำเร็จ`)
                    history.push(routeName.treatmentTemplate)
                } else {
                    notiError("แก้ไขไม่สำเร็จ")
                }
            }).catch((error) => {
                const errMessage = error.response.data?.message
                if (errMessage === 'TEMPLATE_ITEM_QTY_INVALID') {
                    notiError('มีรายการที่มีจำนวนเป็น 0')
                } else if (errMessage === 'IS_DUPLICATE_TREATMENT_TEMPLATE_NAME') {
                    setErrorMessage({ ...errorMessage, TEMPLATE_NAME: 'ชื่อเทมเพลต ซ้ำ' })
                    return
                } else if (errMessage === 'IS_DUPLICATE_TREATMENT_TEMPLATE_NAME_EN') {
                    setErrorMessage({ ...errorMessage, TEMPLATE_NAME_EN: 'ชื่อเทมเพลต(ภาษาอังกฤษ) ซ้ำ' })
                    return
                } else if (errMessage === 'IS_DUPLICATE_TREATMENT_TEMPLATE_CODE') {
                    setErrorMessage({ ...errorMessage, TEMPLATE_CODE: 'รหัสเทมเพลต ซ้ำ' })
                    return
                } else {
                    notiError(t('ERROR'))
                    return
                }
            })
        } else {
            await TemplateApi.create(resultData).then((resp) => {
                if (resp.data) {
                    notiSuccess(`เพิ่มเทมเพลตสำเร็จ`)
                    history.push(routeName.treatmentTemplate)
                } else {
                    notiError("เพิ่มไม่สำเร็จ")
                }
            }).catch((error) => {
                const errMessage = error.response.data?.message
                if (errMessage === 'TEMPLATE_ITEM_QTY_INVALID') {
                    notiError('มีรายการที่มีจำนวนเป็น 0')
                } else if (errMessage === 'IS_DUPLICATE_TREATMENT_TEMPLATE_NAME') {
                    setErrorMessage({ ...errorMessage, TEMPLATE_NAME: 'ชื่อเทมเพลต ซ้ำ' })
                    return
                } else if (errMessage === 'IS_DUPLICATE_TREATMENT_TEMPLATE_NAME_EN') {
                    setErrorMessage({ ...errorMessage, TEMPLATE_NAME_EN: 'ชื่อเทมเพลต(ภาษาอังกฤษ) ซ้ำ' })
                    return
                } else if (errMessage === 'IS_DUPLICATE_TREATMENT_TEMPLATE_CODE') {
                    setErrorMessage({ ...errorMessage, TEMPLATE_CODE: 'รหัสเทมเพลต ซ้ำ' })
                    return
                } else {
                    notiError(t('ERROR'))
                    return
                }
            })
        }

        return
    }

    const headTableSummaryDiagnosis = [
        {
            id: 'no',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.NO`),
            width: '120px'
        },
        {
            id: 'text',
            disablePadding: false,
            label: t(`รหัส`),
            width: '150px'
        },
        {
            id: 'text',
            disablePadding: false,
            label: t(`คำวินิจฉัย`),
        },
        {
            id: 'action',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.ACTION`),
            width: '80px'
        }
    ]

    const renderSummaryDiagnosis = (objData: any, index: number) => {
        const newIndex = index
        const objRenderData = {
            key: index,
            id: index,
            obj: objData,
            // classes: 'bg-white',
            columns: [
                { option: 'TEXT', align: 'center', label: newIndex + 1, class: 'bg-white' },
                { option: 'TEXT', align: 'left', label: objData?.itemCode || '-', class: 'bg-white' },
                { option: 'TEXT', align: 'left', label: objData?.itemName || '-', class: 'bg-white' },
                {
                    option: 'COMPONENT',
                    align: 'center',
                    component: (
                        <Box>
                            {!disabledIsEdit() &&
                                <IconButton disableFocusRipple disableRipple disabled={disabledIsEdit()} onClick={() => {
                                    const result = summaryDiagnosisList.filter((item: any) => item.itemId !== objData?.itemId)
                                    setSummaryDiagnosisList(result)
                                }} className="p-0" sx={{ backgroundColor: 'transparent' }}>
                                    <img src={icons.btnTrash} alt="discard" />
                                </IconButton>}
                        </Box>
                    )
                    , class: 'bg-white'
                }
            ]
        }

        return (
            <TableRowCommon {...objRenderData} />
        )
    }

    const headTableSummary = [
        {
            id: 'no',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.NO`),
            width: '80px'
        },
        {
            id: 'text',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.CODE`),
            width: '200px'
        },
        {
            id: 'text',
            disablePadding: false,
            label: t(`ประเภท`),
            width: '200px'
        },
        {
            id: 'text',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.ITEM`),
        },
        {
            id: 'text',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.QTY`),
            align: 'center',
            width: '165px'
        },
        {
            id: 'price',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.PRICE`),
            width: '165px'
        },
        {
            id: 'price',
            disablePadding: false,
            label: t(`ราคารวม`),
            width: '165px'
        },
        {
            id: 'action',
            disablePadding: false,
            label: t(`TREATMENT_COURSE.FORM.SUMMARY.TABLE.ACTION`),
            width: '80px'
        }
    ]

    const renderSummary = (objData: any, index: number) => {
        const { amount, itemCode, itemId, itemName, priceUnit, unit, type } = objData
        const newIndex = index
        const objRenderData = {
            key: index,
            id: index,
            obj: objData,
            // classes: 'bg-white',
            columns: [
                { option: 'TEXT', align: 'center', label: newIndex + 1, class: 'bg-white' },
                { option: 'TEXT', align: 'left', label: itemCode || '-', class: 'bg-white' },
                { option: 'TEXT', align: 'left', label: type || '-', class: 'bg-white' },
                {
                    option: 'COMPONENT', align: 'left', component: (
                        <Box display='flex' flexDirection="column">
                            <Typography
                                sx={{
                                    textDecoration: (objData?.group === 'MEDICINE' && !disabledIsEdit()) ? 'underline' : null,
                                    cursor: (objData?.group === 'MEDICINE' && !disabledIsEdit()) ? 'pointer' : 'default' // ทำให้เป็น pointer เมื่อ hover
                                }}
                                onClick={() => {
                                    if (objData?.group === 'MEDICINE' && !disabledIsEdit()) {
                                        setMed(_.find(summaryTemplateList, (item) => item?.itemId === itemId))
                                        setModalTable(true)
                                        setIsOpenModalMedicine(true)
                                    }
                                }}
                            > {itemName}</Typography>
                            <Box>
                                <Box>{objData?.productInstructionName} {objData?.dosage} {objData?.productUnitName} {objData?.productUseDetail}</Box>
                                {objData?.productSymptomDetail && objData?.productWarningDetail ? <Box>{objData?.productSymptomDetail}/{objData?.productWarningDetail}</Box> : <Box>{objData?.productSymptomDetail} {objData?.productWarningDetail}</Box>}
                            </Box>
                        </Box>
                    )
                    , class: 'bg-white'
                },
                {
                    option: 'COMPONENT',
                    align: 'center',
                    component: (
                        <InputTextField
                            key={`amount${newIndex}`}
                            inputTextAlign={'right'}
                            value={amount}
                            onchange={(e) => {
                                const value = numberOnly(e); // ฟังก์ชันกรองเฉพาะตัวเลข
                                if (value.length <= 2) {
                                    handleChangeAmount(value, newIndex);
                                }
                            }}
                            disabled={disabledIsEdit()}
                            helperText={listCourseAmount && !amount ? errorMessage.TREATMENT_LIST_AMOUNT : ""}
                        />
                    )
                    , class: 'bg-white'
                },
                { option: 'TEXT', align: 'right', label: `${numberFormat(priceUnit)} / ${unit || '-'}` || '-', class: 'bg-white' },
                { option: 'TEXT', align: 'right', label: numberFormat(priceUnit * amount || 0), class: 'bg-white' },
                {
                    option: 'COMPONENT',
                    align: 'center',
                    component: (
                        <Box>
                            {!disabledIsEdit() && <IconButton disableFocusRipple disableRipple onClick={() => onDelete({ itemId, itemName, amount, priceUnit })} className="p-0" sx={{ backgroundColor: 'transparent' }}>
                                <img src={icons.btnTrash} alt="discard" />
                            </IconButton>}
                        </Box>
                    )
                    , class: 'bg-white'
                }
            ]
        }

        return (
            <TableRowCommon {...objRenderData} />
        )
    }

    const onDelete = (objData: any) => {
        // หา item ที่จะลบ
        const itemToDelete = summaryTemplateList.find((item: any) => item.itemId === objData.itemId)
        if (!itemToDelete) return

        const deletedSort: any = itemToDelete.itemSort

        // ลบ item ที่เลือก
        const items = summaryTemplateList.filter((item: any) => item.itemId !== objData.itemId)

        // ปรับ itemSort ของ item ที่มากกว่า item ที่ถูกลบ
        const finalItems = items.map((item: any) => {
            if (item.itemSort > deletedSort) {
                return { ...item, itemSort: item.itemSort - 1 }
            }
            return item
        })

        setSummaryTemplateList(finalItems)
    }

    const clearErrorMessage = () => {
        setErrorMessage(initStateErrorMessage)
    }

    const onAddProduct = (type: any, items: any, maxLength: number) => {
        setTypeAdd(type);
        setItems(items);
        setMaxLength(maxLength);
        setIsOpenModalMedicine(false)
        setIsShowAddProductChoice(true);
        dispatch(showModal());
    };

    const handleSubmit = (data: any, type: any) => {
        const autoSelect: any = {
            PRODUCT_INSTRUCTION: { productInstructionId: data.productInstructionId, productInstructionName: data.productInstructionName, productInstructionNameEn: data.productInstructionNameEn },
            PRODUCT_UNITS: { productUnitId: data.productUnitId, productUnitName: data.productUnitName, productUnitNameEn: data.productUnitNameEn },
            PRODUCT_USES: { productUseId: data.productUseId, productUseDetail: data.productUseDetail, productUseDetailEn: data.productUseDetailEn },
            PRODUCT_SYMPTOM: { productSymptomId: data.productSymptomId, productSymptomDetail: data.detail, productSymptomDetailEn: data.detailEn },
            PRODUCT_WARNING: { productWarningId: data.productWarningId, productWarningDetail: data.productWarningName }
        }
        reloadProduct()
        setMed({ ...med, ...autoSelect[type] })
        setIsOpenModalMedicine(true)
        setIsShowAddProductChoice(false)
        return
    }

    return (
        <Box>
            <PageModal
                isOpen={isOpenModalMedicine}
                title={t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MEDICINE_TITLE`)}
                size='S'
                handleClose={() => setIsOpenModalMedicine(false)}
                onCancel={{ onClick: () => setIsOpenModalMedicine(false) }}
                onSubmit={{
                    onClick: () => {
                        onAdd(med)
                    }
                }}
            >
                <Box>
                    <Loading show={loading} />
                    <Box display="flex" flexDirection="row" alignItems="center" gap="24px">
                        <Typography>รหัส : {med?.itemCode}</Typography>
                        <Typography>ชื่อยา : {med?.itemName}</Typography>
                    </Box>
                    <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-8px !important', marginRight: '-8px !important', marginY: '16px' }} />

                    <Grid container spacing="8px">
                        <Grid item xs={3}>
                            <Box border={1} display="flex" justifyContent="center" borderColor={colors.lightGray} >
                                <img src={med?.image ? `${fileUrl}/${med?.image?.filePath}/${med?.image?.fileName}` : icons.medDefault} alt="med" width={182} height={150} className='object-cover' />
                            </Box>

                            {/* <Box display="flex" justifyContent="space-between" alignItems="center" marginTop="8px">
                                <Typography fontSize="12px" color={colors.gray}>คงเหลือ</Typography>
                                <Typography fontSize="12px" color={colors.gray}>{med?.qty} {med?.unit}</Typography>
                            </Box> */}
                        </Grid>
                        <Grid item xs={9}>
                            <Box display="flex" flexDirection="row" alignItems="center">
                                <AutocompleteSelect
                                    labelId="productInstructionId"
                                    inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_INSTRUCTION')}
                                    getOptionLabel={(option: any) => option.name || med?.productInstructionName || med?.productInstruction?.productInstructionName || ''}
                                    noOptionsText={t('NOT_FOUND')}
                                    options={productInstructions}
                                    // onOpen={(e: any) => loadInstruction()}
                                    loading={dataLoading}
                                    renderOption={(props, option: any) => (
                                        <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                            {option.name}
                                            <IconButton className={`p-0`}
                                                onClick={() => handleDiscard("productInstructionId", option.id)}
                                                sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }}>
                                                <img src={icons.btnTrash} alt="discard" />
                                            </IconButton>
                                        </Box>
                                    )}
                                    sxAutoComplete={{ width: '100%' }}
                                    onchange={(_e, value: any) => {
                                        const newMed = {
                                            ...med,
                                            productInstructionId: value?.id || 0,
                                            productInstructionName: _.get(_.find(productInstructions, { id: value?.id || 0 }), 'name')
                                        }
                                        setMed(newMed)
                                    }}
                                    inputProps={{
                                        onChange: (e: any) => {
                                            setDataLoading(true)
                                            setProductInstructions([])
                                            // const newMed = {
                                            //     ...med,
                                            //     productInstructionName: e.target.value
                                            // }
                                            // setMed(newMed)
                                            handleInputSearch('productInstructions', e.target.value)
                                        }
                                    }}
                                    value={med?.productInstructionId ? _.find(productInstructions, { id: med?.productInstructionId }) || '' : null}
                                    disableClearable={!med?.productInstructionId}
                                />
                                <IconAddBox className="" sx={{ backgroundColor: 'transparent !important' }} onClick={() => onAddProduct("PRODUCT_INSTRUCTION", productInstructions, 80)}>
                                    <AddBoxIcon style={{ width: 40, height: 40 }} />
                                </IconAddBox>
                            </Box>
                            <Box display="flex" flexDirection="row" alignItems="center" >
                                <Box width={'30%'} marginRight='8px'>
                                    <InputTextField
                                        type='number'
                                        hideControl
                                        value={!med?.dosage ? 1 : med?.dosage || 1}
                                        onchange={(e: any) => {
                                            const valueNumber = !e.target.value ? 0 : String(e.target.value).replace(/[^0-9.]/g, '')
                                            const newMed = { ...med, dosage: Number(valueNumber) }
                                            setMed(newMed)
                                        }}
                                        label={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_DOSAGE')} />
                                </Box>
                                <Box width={'100%'}>
                                    <AutocompleteSelect
                                        inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_UNIT')}
                                        labelId="productUnitId"
                                        noOptionsText={t('NOT_FOUND')}
                                        options={productUnits}
                                        getOptionLabel={(option: any) => option.name || med?.productUnitName || med?.productUnit?.productUnitName || ''}
                                        renderOption={(props, option: any) => (
                                            <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                {option.name}
                                                <IconButton className={`p-0`}
                                                    onClick={() => handleDiscard("productUnitId", option.id)}
                                                    sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }}>
                                                    <img src={icons.btnTrash} alt="discard" />
                                                </IconButton>
                                            </Box>
                                        )}
                                        onchange={(e, value: any) => {
                                            const newMed = {
                                                ...med,
                                                productUnitId: value?.id || 0,
                                                productUnitName: _.get(_.find(productUnits, { id: value?.id || 0 }), 'name'),
                                                productUnitNameEn: _.get(_.find(productUnits, { id: value?.id || 0 }), 'nameEn'),
                                            }
                                            setMed(newMed)
                                        }}
                                        inputProps={{
                                            onChange: (e: any) => {
                                                setDataLoading(true)
                                                setProductUnits([])
                                                // const newMed = {
                                                //     ...med,
                                                //     productUnitName: e.target.value
                                                // }
                                                // setMed(newMed)
                                                handleInputSearch('productUnits', e.target.value)
                                            }
                                        }}
                                        // onOpen={(e: any) => loadUnit()}
                                        value={med?.productUnitId ? _.find(productUnits, { id: med?.productUnitId }) || '' : null}
                                        loading={dataLoading}
                                        disableClearable={!med?.productUnitId}
                                    />
                                </Box>
                                <Box>
                                    <IconAddBox className="" sx={{ backgroundColor: 'transparent !important' }} onClick={() => onAddProduct('PRODUCT_UNITS', productUnits, 10)}>
                                        <AddBoxIcon style={{ width: 40, height: 40 }} />
                                    </IconAddBox>
                                </Box>
                            </Box>
                            <Box display="flex" flexDirection="row" alignItems="center" >
                                <AutocompleteSelect
                                    inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_USE')}
                                    labelId="productUseId"
                                    noOptionsText={t('NOT_FOUND')}
                                    options={productUses}
                                    getOptionLabel={(option: any) => option.name || med?.productUseDetail || med?.productUse?.productUseDetail || ''}
                                    sxAutoComplete={{ width: '100%' }}
                                    renderOption={(props, option: any) => (
                                        <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                            {option.name}
                                            <IconButton className={`p-0`}
                                                onClick={() => handleDiscard("productUseId", option.id)}
                                                sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }}>
                                                <img src={icons.btnTrash} alt="discard" />
                                            </IconButton>
                                        </Box>
                                    )}
                                    onchange={(e, value: any) => {
                                        const newMed = {
                                            ...med,
                                            productUseId: value?.id || 0,
                                            productUseDetail: _.get(_.find(productUses, { id: value?.id || 0 }), 'name')
                                        }
                                        setMed(newMed)
                                    }}
                                    inputProps={{
                                        onChange: (e: any) => {
                                            setDataLoading(true)
                                            setProductUses([])
                                            // const newMed = {
                                            //     ...med,
                                            //     productUseDetail: e.target.value
                                            // }
                                            // setMed(newMed)
                                            handleInputSearch('productUses', e.target.value)
                                        }
                                    }}
                                    // onOpen={(e: any) => loadUses()}
                                    value={med?.productUseId ? _.find(productUses, { id: med?.productUseId }) || '' : null}
                                    loading={dataLoading}
                                />
                                <IconAddBox className="" sx={{ backgroundColor: 'transparent !important' }} onClick={() => onAddProduct('PRODUCT_USES', productUses, 40)}>
                                    <AddBoxIcon style={{ width: 40, height: 40 }} />
                                </IconAddBox>
                            </Box>
                            <Box display="flex" flexDirection="row" alignItems="center" >
                                <AutocompleteSelect
                                    inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.SYMPTOM')}
                                    labelId="productSymptomId"
                                    noOptionsText={t('NOT_FOUND')}
                                    options={productSymptom}
                                    getOptionLabel={(option: any) => option.name || med?.productSymptomDetail || med?.productSymptom?.name || ''}
                                    sxAutoComplete={{ width: '100%' }}
                                    renderOption={(props, option: any) => (
                                        <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                            {option.name}
                                            <IconButton className={`p-0`}
                                                onClick={() => handleDiscard("productSymptomId", option.id)}
                                                sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }} >
                                                <img src={icons.btnTrash} alt="discard" />
                                            </IconButton>
                                        </Box>
                                    )}
                                    onchange={(e, value: any) => {
                                        const newMed = {
                                            ...med,
                                            productSymptomId: value?.id || 0,
                                            productSymptomDetail: _.get(_.find(productSymptom, { id: value?.id || 0 }), 'name')
                                        }
                                        setMed(newMed)
                                    }}
                                    inputProps={{
                                        onChange: (e: any) => {
                                            setDataLoading(true)
                                            setProductSymptom([])
                                            // const newMed = {
                                            //     ...med,
                                            //     productSymptomDetail: e.target.value
                                            // }
                                            // setMed(newMed)
                                            handleInputSearch('productSymptom', e.target.value)
                                        }
                                    }}
                                    // onOpen={(e: any) => loadSymtom()}
                                    value={med?.productSymptomId ? _.find(productSymptom, { id: med?.productSymptomId }) || '' : null}
                                    loading={dataLoading}
                                />
                                <IconAddBox className="" sx={{ backgroundColor: 'transparent !important' }} onClick={() => onAddProduct('PRODUCT_SYMPTOM', productSymptom, 40)}>
                                    <AddBoxIcon style={{ width: 40, height: 40 }} />
                                </IconAddBox>
                            </Box>
                            <Box display="flex" flexDirection="row" alignItems="center" >
                                <AutocompleteSelect
                                    inputLabel={t('ข้อควรระวัง')}
                                    labelId="productWarningId"
                                    noOptionsText={t('NOT_FOUND')}
                                    options={productWarning}
                                    getOptionLabel={(option: any) => option.name || med?.productWarningDetail || med?.productWarning?.productWarningName || ''}
                                    sxAutoComplete={{ width: '100%' }}
                                    renderOption={(props, option: any) => (
                                        <Box component="li" {...props} sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            flexDirection: 'row',
                                            gap: 1,
                                        }}>
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                }}
                                            >
                                                {option.name}
                                            </Box>
                                            <IconButton className={`p-0`}
                                                onClick={() => handleDiscard("productWarningId", option.id)}
                                                sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }} >
                                                <img src={icons.btnTrash} alt="discard" />
                                            </IconButton>
                                        </Box>
                                    )}
                                    onchange={(e, value: any) => {
                                        const newMed = {
                                            ...med,
                                            productWarningId: value?.id || 0,
                                            productWarningDetail: _.get(_.find(productWarning, { id: value?.id || 0 }), 'name')
                                        }
                                        setMed(newMed)
                                    }}
                                    inputProps={{
                                        onChange: (e: any) => {
                                            setDataLoading(true)
                                            setProductWarning([])
                                            handleInputSearch('productWarning', e.target.value)
                                        }
                                    }}
                                    // onOpen={(e: any) => loadWarning()}
                                    value={med?.productWarningId ? _.find(productWarning, { id: med?.productWarningId }) || '' : null}
                                    loading={dataLoading}
                                />
                                <IconAddBox className="" sx={{ backgroundColor: 'transparent !important' }} onClick={() => onAddProduct('PRODUCT_WARNING', productWarning, 40)}>
                                    <AddBoxIcon style={{ width: 40, height: 40 }} />
                                </IconAddBox>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </PageModal>
            {isShowAddProductChoice && (
                <PopupManageProductAddForm
                    type={typeAdd}
                    items={items}
                    isShow={isShowAddProductChoice}
                    onSubmit={(data, type) => handleSubmit(data, type)}
                    onCancel={() => setIsShowAddProductChoice(false)}
                    maxLength={maxLength}
                />
            )}
            <HeaderLabel
                onSubmit={onSubmit}
                text={dataEdit?.treatmentTemplateId ? window.location.pathname === '/treatment-template/view' ? 'ดูเทมเพลต' : t('TREATMENT_TEMPLATE.FORM.EDIT_TITLE') : t('TREATMENT_TEMPLATE.FORM.ADD_TITLE')}
                navigator={{ previousTo: routeName.treatmentTemplate, previousTitle: t('OPERATIVE.TITLE'), currentTitle: dataEdit?.treatmentTemplateId ? window.location.pathname === '/treatment-template/view' ? 'ดูเทมเพลต' : t('TREATMENT_TEMPLATE.FORM.EDIT_TITLE') : t('TREATMENT_TEMPLATE.FORM.ADD_TITLE') }}
                goBack={routeName.treatmentTemplate}
                hideButtonSubmit={disabledIsEdit()}
            />
            <Box padding="24px">
                <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
                    <Grid container spacing={2}>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextInput
                                onChange={(event) => {
                                    setTemplateName(event.target.value)
                                    clearErrorMessage()
                                }}
                                value={templateName}
                                helperText={errorMessage.TEMPLATE_NAME}
                                label={t('TREATMENT_TEMPLATE.FORM.TEMPLATE_NAME')}
                                required
                                fullWidth
                                maxLength={255}
                                disabled={disabledIsEdit()}
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextInput
                                onChange={(event) => {
                                    setTemplateNameEn(event.target.value)
                                    clearErrorMessage()
                                }}
                                value={templateNameEn}
                                helperText={errorMessage.TEMPLATE_NAME_EN}
                                label={t('TREATMENT_TEMPLATE.FORM.TEMPLATE_NAME_EN')}
                                fullWidth
                                required
                                maxLength={255}
                                disabled={disabledIsEdit()}
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-8px !important', marginRight: '-8px !important', marginY: '16px' }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>{t('TREATMENT_TEMPLATE.FORM.TEMPLATE_DETAIL')}</Typography>
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextInput
                                onChange={(event) => {
                                    setTemplateCode(event.target.value)
                                    clearErrorMessage()
                                }}
                                value={templateCode}
                                helperText={errorMessage.TEMPLATE_CODE}
                                label={t('TREATMENT_TEMPLATE.FORM.TEMPLATE_CODE')}
                                required
                                fullWidth
                                maxLength={20}
                                disabled={disabledIsEdit()}
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <SelectInput
                                onChange={(e) => {
                                    setTemplateTypeId(e.target.value)
                                    clearErrorMessage()
                                }}
                                value={templateTypeId}
                                options={templateTypeOption.map((item: any) => ({ name: item?.treatmentTemplateTypeName, value: item?.treatmentTemplateTypeId }))}
                                label={t('TREATMENT_TEMPLATE.FORM.TEMPLATE_TYPE')}
                                helperText={errorMessage.TEMPLATE_TYPE_ID}
                                required
                                disabled={disabledIsEdit()}
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextInput
                                onChange={(event) => {
                                    setTemplateDescription(event.target.value)
                                    clearErrorMessage()
                                }}
                                value={templateDescription}
                                label={t('TREATMENT_TEMPLATE.FORM.TEMPLATE_DESCRIPTION')}
                                fullWidth
                                maxLength={255}
                                disabled={disabledIsEdit()}
                            />
                        </Grid>

                        <Grid item sm={12} md={6} lg={4}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <CheckboxButton disabled={disabledIsEdit()} onChange={(e) => {
                                    setSelectCheckbox(!selectCheckbox)
                                    !e.target.checked && setSelectBranch([getBranch()])
                                }} checked={selectCheckbox} label={t('TREATMENT_TEMPLATE.FORM.LINK_MANY_BRANCH')} />
                                <ButtonInfoSimple text={t('เทมเพลตที่เชื่อมต่อไปยังสาขาอื่น จะสามารถแก้ไขหรือลบได้เฉพาะสาขาที่สร้างเท่านั้น')} />
                                <ClickAwayListener onClickAway={() => setOpenFilterBranch(false)}>
                                    <CustomFilterDoctor style={{ width: '60%' }} open={openFilterBranch} onClick={() => { selectCheckbox && !disabledIsEdit() && setOpenFilterBranch(true) }}>
                                        <AutocompleteSelect
                                            disabled={!selectCheckbox ? true : false || disabledIsEdit()}
                                            open={openFilterBranch}
                                            multiple
                                            labelId="label-doctors"
                                            options={['ALL', ...branches, 'CLEAR']}
                                            getOptionLabel={(option) => _.find(branches, { branchId: option.branchId })?.branchName || '-'}
                                            renderOption={(props, option) => {
                                                if (option === 'ALL') {
                                                    return (
                                                        <ListFilterDoctors {...props} key={option} component="li" value={option}>
                                                            <InputCheckbox
                                                                label={t('REPORT.REPORT_GROUP.ALL')}
                                                                checked={_.size(selectBranch.filter((item) => typeof item === 'number')) === _.size(branches)}
                                                                indeterminate={_.size(selectBranch) > 1 && _.size(selectBranch.filter((item) => typeof item === 'number')) !== _.size(branches)}
                                                                className={'pe-none'}
                                                            />
                                                        </ListFilterDoctors>
                                                    )
                                                } else if (option === 'CLEAR') {
                                                    return (
                                                        <Box {...props} key={option} component="li" value={option} sx={{ borderTop: `1px solid ${colors.lightGray}` }}>
                                                            <SpanClearFilter className="pe-none">{t('REPORT.FILTER.CLEAR_FILTER')}</SpanClearFilter>
                                                        </Box>
                                                    )
                                                } else {
                                                    return (
                                                        <ListFilterDoctors {...props} key={option.branchId} component="li" value={option.branchId} sx={{ paddingTop: '5px' }} >
                                                            <InputCheckbox label={option.branchName} checked={_.includes(selectBranch, option.branchId)} className={'pe-none'} />
                                                        </ListFilterDoctors>
                                                    )
                                                }
                                            }}
                                            renderTags={(tagValue, getTagProps) => {
                                                return (
                                                    <>
                                                        <Box sx={{ paddingTop: '5px' }}><span className="pr-1">{t('TEMPLATE_DOCTOR_FEE.FORM.BRANCH')}:</span></Box>
                                                        {!openFilterBranch &&
                                                            ((_.size(tagValue.filter((item: any) => typeof item === 'number')) === _.size(branches) && <Box sx={{ paddingTop: '5px' }}><span>{t('REPORT.REPORT_GROUP.ALL')}</span></Box>) || (
                                                                <Box className="text-ellipsis" sx={{ paddingTop: '5px' }}>
                                                                    {_.map(tagValue, (option: any, index: number) => {
                                                                        return (
                                                                            <span>
                                                                                {_.find(branches, { branchId: option })?.branchName}
                                                                                {index !== _.findLastIndex(tagValue) && option && `,`}
                                                                            </span>
                                                                        )
                                                                    })}
                                                                </Box>
                                                            ))}
                                                    </>
                                                )
                                            }}
                                            onchange={(e, value) => handleChangeSelectBranch(e?.target?.value || e?.target?.attributes?.value?.value)}
                                            noOptionsText={t('NOT_FOUND')}
                                            filterOptions={(option) => 'ALL' + option.branchName + 'CLEAR'}
                                            value={selectBranch}
                                            height={40}
                                            disableClearable
                                        />
                                    </CustomFilterDoctor>
                                </ClickAwayListener>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ display: 'flex', flexGrow: 1, bgcolor: 'background.paper', marginTop: '16px' }}>
                        <Box>
                            <UseStyled.CustomTabs orientation="vertical" variant="scrollable" value={activeTab} onChange={handleChangeTab} sx={{ display: 'flex', flex: 'none' }}>
                                {_.map(tabs, (tab: string, index: number) => {
                                    return <Tab key={index} label={tab} {...a11yProps(tab)} />
                                })}
                            </UseStyled.CustomTabs>
                        </Box>
                        <TabPanel value={activeTab} index={0}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px" marginTop="8px">
                                <Typography sx={{ color: colors.themeMainColor, fontWeight: 600 }}>{t('รายการคำวินิจฉัย (DX)')}</Typography>
                                <Box width="100%" sx={{ maxWidth: 379 }}>
                                    <TextInput
                                        label={t('ค้นหา รหัส / คำวินิจฉัย')}
                                        value={searchDiagnosis}
                                        onChange={(event) => {
                                            setSearchDiagnosis(event.target.value)
                                            setPageDiagnosis(1)
                                            debouncedLoadDiagnosis(event.target.value, 1, selectFilterDiagnosis)
                                        }}
                                        fullWidth
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end" >
                                                    {!searchDiagnosis ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                        <FontAwesomeIcon
                                                            icon={faTimes}
                                                            onClick={() => {
                                                                setSearchDiagnosis('');
                                                                setPageDiagnosis(1)
                                                                debouncedLoadDiagnosis('', 1, selectFilterDiagnosis)
                                                            }}
                                                            style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                            <UsedTxPlanStyled.TypeTabs style={{ display: 'flex', flexWrap: 'wrap', marginRight: 0 }}>
                                <Box paddingX="4px" paddingBottom="8px">
                                    <UsedTxPlanStyled.ButtonType
                                        variant="outlined"
                                        title={t('All')}
                                        className={`${selectFilterDiagnosis === 'ALL' ? 'active' : ''} overflow-hidden`}
                                        data-value={'All'} onClick={(e) => {
                                            setSelectFilterDiagnosis('ALL')
                                            setPageDiagnosis(1)
                                        }}>
                                        <span className="text-ellipsis">{t('All')}</span>
                                    </UsedTxPlanStyled.ButtonType>
                                </Box>
                                {diagnosisType.map(({ diagnosisTypeName, diagnosisTypeNameEn, diagnosisTypeId }: any) => {
                                    return (
                                        <Box key={`col-operative-type-${diagnosisTypeId}`} paddingX="4px" paddingBottom="8px">
                                            <UsedTxPlanStyled.ButtonType variant="outlined" title={diagnosisTypeName || diagnosisTypeNameEn} key={diagnosisTypeId} data-value={diagnosisTypeId} onClick={(e) => {
                                                setSelectFilterDiagnosis(diagnosisTypeId)
                                                setPageDiagnosis(1)

                                            }}
                                                className={`${selectFilterDiagnosis === diagnosisTypeId ? 'active' : ''} text-ellipsis`}
                                            >
                                                <span className="text-ellipsis">{diagnosisTypeName || diagnosisTypeNameEn}</span>
                                            </UsedTxPlanStyled.ButtonType>
                                        </Box>
                                    )
                                })}
                            </UsedTxPlanStyled.TypeTabs>
                            <Box marginTop="8px">
                                <TableCustom
                                    page={pageDiagnosis}
                                    pageLimit={pageLimitDiagnosis}
                                    sortType={sortTypeDiagnosis}
                                    sortBy={sortByDiagnosis}
                                    onSort={(sortByVal: string, sortTypeVal: string) => {
                                        setSortTypeDiagnosis(sortTypeVal)
                                        setSortByDiagnosis(sortByVal)
                                    }}
                                    setPageLimit={(limit: number) => setPageLimitDiagnosis(limit)}
                                    setPage={(val: number) => {
                                        setPageDiagnosis(val)
                                        debouncedLoadDiagnosis(searchDiagnosis, val, selectFilterDiagnosis)
                                    }}
                                    rowCount={rowCountDiagnosis}
                                    headCells={headCellsDiagnosis}
                                    rowsData={diagnosis.map((val: any, i: any) => {
                                        return renderDataDiagnosis(val, i)
                                    })}
                                    tableMinWidth={1280}
                                />
                            </Box>
                        </TabPanel>
                        <TabPanel value={activeTab} index={1}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px" marginTop="8px">
                                <Typography sx={{ color: colors.themeMainColor, fontWeight: 600 }}>{t('รายการหัตถการ (TX)')}</Typography>
                                <Box width="100%" sx={{ maxWidth: 379 }}>
                                    <TextInput
                                        label={t('ค้นหา ประเภท / รหัส / บริการ')}
                                        value={search}
                                        onChange={(event) => {
                                            setSearch(event.target.value)
                                            setPage(1)
                                            debouncedLoadOperative(event.target.value, 1, selectFilterOperative)
                                        }}
                                        fullWidth
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end" >
                                                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                        <FontAwesomeIcon
                                                            icon={faTimes}
                                                            onClick={() => {
                                                                setSearch('')
                                                                setPage(1)
                                                                debouncedLoadOperative('', 1, selectFilterOperative)
                                                            }}
                                                            style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>

                            <UsedTxPlanStyled.TypeTabs style={{ display: 'flex', flexWrap: 'wrap', marginRight: 0 }}>
                                <Box paddingX="4px" paddingBottom="8px">
                                    <UsedTxPlanStyled.ButtonType
                                        variant="outlined"
                                        title={t('All')}
                                        className={`${selectFilterOperative === 'ALL' ? 'active' : ''} overflow-hidden`}
                                        data-value={'All'} onClick={(e) => {
                                            setSelectFilterOperative('ALL')
                                            setPage(1)
                                        }}>
                                        <span className="text-ellipsis">{t('All')}</span>
                                    </UsedTxPlanStyled.ButtonType>
                                </Box>
                                {operativeType.map(({ operativeTypeName, operativeTypeNameEn, operativeTypeId }: any) => {
                                    return (
                                        <Box key={`col-operative-type-${operativeTypeId}`} paddingX="4px" paddingBottom="8px">
                                            <UsedTxPlanStyled.ButtonType variant="outlined" title={operativeTypeName || operativeTypeNameEn} key={operativeTypeId} data-value={operativeTypeId} onClick={(e) => {
                                                setSelectFilterOperative(operativeTypeId)
                                                setPage(1)

                                            }}
                                                className={`${selectFilterOperative === operativeTypeId ? 'active' : ''} text-ellipsis`}
                                            >
                                                <span className="text-ellipsis">{operativeTypeName || operativeTypeNameEn}</span>
                                            </UsedTxPlanStyled.ButtonType>
                                        </Box>
                                    )
                                })}
                            </UsedTxPlanStyled.TypeTabs>
                            <Box marginTop="8px">
                                <TableCustom
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortType={sortType}
                                    sortBy={sortBy}
                                    onSort={onRequestSort}
                                    setPageLimit={handleChangeRowsPerPage}
                                    setPage={handleChangePage}
                                    rowCount={rowCount}
                                    headCells={headCells}
                                    rowsData={operatives.map((val: any, i: any) => {
                                        return renderData(val, i)
                                    })}
                                    tableMinWidth={1280}
                                />
                            </Box>
                        </TabPanel>
                        <TabPanel value={activeTab} index={2}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px" marginTop="8px">
                                <Typography sx={{ color: colors.themeMainColor, fontWeight: 600 }}>{t('รายการยา (MED)')}</Typography>
                                <Box width="100%" sx={{ maxWidth: 379 }}>
                                    <TextInput
                                        label={t('ค้นหา รหัส / ชื่อยา')}
                                        value={searchProduct}
                                        onChange={(event) => {
                                            setSearchProduct(event.target.value)
                                            debouncedLoadProduct(event.target.value, 'MEDICINE')
                                        }}
                                        fullWidth
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end" >
                                                    {!searchProduct ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                        <FontAwesomeIcon
                                                            icon={faTimes}
                                                            onClick={() => {
                                                                setSearchProduct('');
                                                                loadProduct('', "MEDICINE")
                                                            }}
                                                            style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                            <TypeTabs style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <Box paddingX="4px" paddingTop="8px" >
                                    <ButtonType variant="outlined" title={t('All')} className={`${typeSelected === 'ALL' || typeSelected === 0 ? 'active' : ''} overflow-hidden`} data-value={'All'} onClick={() => setTypeSelected('ALL')} key={`type-all`}>
                                        <span className="text-ellipsis">{t('All')}</span>
                                    </ButtonType>
                                </Box>
                                {_.map(productTypes, (type: any, index: number) => {
                                    if (type.group === 'MEDICINE') {
                                        return (
                                            <Box key={`med-type-${index}`} paddingX="4px" paddingTop="8px">
                                                <ButtonType variant="outlined" key={type.productTypeId} title={type.productTypeName || type.productTypeNameEn} onClick={() => setTypeSelected(type.productTypeId)} className={`${Number(typeSelected) === Number(type.productTypeId) ? 'active' : ''} text-ellipsis`}>
                                                    <span className="text-ellipsis">{type.productTypeName || type.productTypeNameEn}</span>
                                                </ButtonType>
                                            </Box>
                                        )
                                    }
                                })}
                            </TypeTabs>
                            <ProductItem display="flex" flexWrap="wrap" alignItems="start" marginTop="16px">
                                {!_.isEmpty(medicines) && (
                                    _.map(medicines, (med: any, index: number) => {
                                        return (
                                            <ProductBox key={`med-${index}`} sx={{
                                                px: '8px',
                                                mb: { xs: 2, xl: 3 },
                                                mt: '16px'
                                            }}>
                                                <ProductCard
                                                    onClick={async () => {
                                                        setModalTable(false)
                                                        if (!disabledIsEdit()) {
                                                            if (_.find(summaryTemplateList, (item) => item?.itemId === med?.itemId)) {
                                                                setMed(_.find(summaryTemplateList, (item) => item?.itemId === med?.itemId))
                                                                setIsOpenModalMedicine(true)
                                                            } else {
                                                                await MedicinesApi.findById(med?.itemId).then((resp: any) => {
                                                                    setMed({ ...med, ...resp.data })
                                                                    setIsOpenModalMedicine(true)
                                                                }).catch(() => notiError(t('ERROR')))
                                                            }
                                                        }
                                                    }}
                                                    style={{ border: handleProductBorder(med.itemId) ? `1px solid ${colors.themeSecondColor}` : '' }}>
                                                    <Box className='card-image'>
                                                        <Box position="relative">
                                                            {Number(med.qty) <= 0 && <span className='position-absolute top-50 start-50 translate-middle fw-bolder' style={{ fontSize: '20px', opacity: 0.9, zIndex: 1, borderBottom: '3px solid', paddingBottom: '' }}>{t('TREATMENT_PRODUCT.MEDICINE.OUT_STOCK')}</span> || <span></span>}
                                                            <img src={renderImage(med?.img)} alt={med.itemName} className={`${_.isEmpty(med?.img) || !med?.img?.filePath || !med?.img?.fileName ? 'no-prod-image' : ''}`} onError={onImgError} style={{ ...(Number(med.qty) <= 0 && { opacity: 0.5 }) }} />
                                                        </Box>
                                                    </Box>
                                                    <Box className='card-detail'>
                                                        <Typography fontSize={11} color="#707070">{med?.itemCode}</Typography>
                                                        <Box display="flex" justifyContent="space-between" alignItems="start">
                                                            <Box overflow="hidden">
                                                                <Tooltip title={med.itemName} placement='top-start'><Typography className='text-ellipsis' sx={{ flex: 1 }}>{med.itemName || '-'}</Typography></Tooltip>
                                                                <Typography className='text-ellipsis'>
                                                                    {checkAddons(PACKAGE_ADDONS.ADDON_PRICE_RANGE) && med?.isPriceRange === '1' && med?.minSalePrice && med?.maxSalePrice 
                                                                        ? `${numberFormat(med.minSalePrice)} - ${numberFormat(med.maxSalePrice)}` 
                                                                        : numberFormat(med.price || 0)} {t('CURRENCY_CHANGE.TH')}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ display: 'block', textAlign: 'right', marginTop: '4px' }}>
                                                                <Box><AddIcon style={{ height: '24px', width: '24px', color: colors.white, backgroundColor: disabledIsEdit() ? colors.lightGray : colors.themeSecondColor, cursor: 'pointer', borderRadius: '4px' }} /></Box>
                                                                {Number(med?.qty) > 0 &&
                                                                    <Box>
                                                                        <InventoryChip label={`${t('TREATMENT_PRODUCT.CARD.QUANTITY')}: ${numberFormat(med.qty, 0, 0)}`} limit={med.qty <= med.minStock} className="ml-2 p-0" />
                                                                    </Box>
                                                                }
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </ProductCard>
                                            </ProductBox>
                                        )
                                    })
                                ) || (
                                        <Typography textAlign="center" width="100%" sx={{ color: colors.disabledGray, paddingTop: '48px' }}>{t('TREATMENT_PRODUCT.TITLE.EMPTY_MEDICINE')}</Typography>
                                    )}
                            </ProductItem>
                        </TabPanel>
                        <TabPanel value={activeTab} index={3}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px" marginTop="8px">
                                <Typography sx={{ color: colors.themeMainColor, fontWeight: 600 }}>{t('รายการผลิตภัณฑ์ (PD)')}</Typography>
                                <Box width="100%" sx={{ maxWidth: 379 }}>
                                    <TextInput
                                        label={t('ค้นหา รหัส / ชื่อผลิตภัณฑ์')}
                                        value={searchProduct}
                                        onChange={(event) => {
                                            setSearchProduct(event.target.value)
                                            debouncedLoadProduct(event.target.value, 'PRODUCT')
                                        }}
                                        fullWidth
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end" >
                                                    {!searchProduct ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                        <FontAwesomeIcon
                                                            icon={faTimes}
                                                            onClick={() => {
                                                                setSearchProduct('');
                                                                loadProduct('', "PRODUCT")
                                                            }}
                                                            style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                            <TypeTabs sx={{ display: 'flex', flexWrap: 'wrap' }} >
                                <Box paddingX="4px" paddingTop="8px" >
                                    <ButtonType variant="outlined" title={t('All')} className={`${typeSelected === 'ALL' || typeSelected === 0 ? 'active' : ''} overflow-hidden`} data-value={'All'} onClick={() => setTypeSelected('ALL')} key={`type-all`}>
                                        <span className="text-ellipsis">{t('All')}</span>
                                    </ButtonType>
                                </Box>
                                {_.map(productTypes, (type: any, index: number) => {
                                    if (type.group === 'PRODUCT') {
                                        return (
                                            <Box key={`med-type-${index}`} paddingX="4px" paddingTop="8px">
                                                <ButtonType variant="outlined" key={type.productTypeId} title={type.productTypeName || type.productTypeNameEn} onClick={() => setTypeSelected(type.productTypeId)} className={`${Number(typeSelected) === Number(type.productTypeId) ? 'active' : ''} text-ellipsis`}>
                                                    <span className="text-ellipsis">{type.productTypeName || type.productTypeNameEn}</span>
                                                </ButtonType>
                                            </Box>
                                        )
                                    }
                                })}
                            </TypeTabs>
                            <ProductItem display="flex" flexWrap="wrap" alignItems="start" marginTop="16px">
                                {!_.isEmpty(products) && (
                                    _.map(products, (prod: any, index: number) => {
                                        return (
                                            <ProductBox key={`prod-${index}`} sx={{
                                                px: '8px',
                                                mb: { xs: 2, xl: 3 },
                                                mt: '16px'
                                            }}>
                                                <ProductCard onClick={() => !disabledIsEdit() && onAdd(prod)} style={{ border: handleProductBorder(prod.itemId) ? `1px solid ${colors.themeSecondColor}` : '' }}>
                                                    <Box className='card-image'>
                                                        <Box position="relative">
                                                            {Number(prod.qty) <= 0 && <span className='position-absolute top-50 start-50 translate-middle fw-bolder' style={{ fontSize: '20px', opacity: 0.9, zIndex: 1, borderBottom: '3px solid', paddingBottom: '' }}>{t('TREATMENT_PRODUCT.MEDICINE.OUT_STOCK')}</span> || <span></span>}
                                                            <img src={renderImage(prod?.img)} alt={prod.itemName} className={`${_.isEmpty(prod?.img) || !prod?.img?.filePath || !prod?.img?.fileName ? 'no-prod-image' : ''}`} onError={onImgError} style={{ ...(Number(prod.qty) <= 0 && { opacity: 0.5 }) }} />
                                                        </Box>
                                                    </Box>
                                                    <Box className='card-detail'>
                                                        <Typography fontSize={11} color="#707070">{prod?.itemCode}</Typography>
                                                        <Box display="flex" justifyContent="space-between" alignItems="start">
                                                            <Box overflow="hidden">
                                                                <Tooltip title={prod?.itemName} placement='top-start'><Typography className='text-ellipsis' sx={{ flex: 1 }}>{prod.itemName || '-'}</Typography></Tooltip>
                                                                <Typography className='text-ellipsis'>
                                                                    {checkAddons(PACKAGE_ADDONS.ADDON_PRICE_RANGE) && prod?.isPriceRange === '1' && prod?.minSalePrice && prod?.maxSalePrice 
                                                                        ? `${numberFormat(prod.minSalePrice)} - ${numberFormat(prod.maxSalePrice)}` 
                                                                        : numberFormat(prod.price || 0)} {t('CURRENCY_CHANGE.TH')}
                                                                </Typography>
                                                            </Box>
                                                            <Box marginTop="4px" sx={{ display: 'block', textAlign: 'right' }}>
                                                                <Box>
                                                                    <AddIcon style={{ height: '24px', width: '24px', color: colors.white, backgroundColor: disabledIsEdit() ? colors.lightGray : colors.themeSecondColor, cursor: 'pointer', borderRadius: '4px' }} />
                                                                </Box>
                                                                {Number(prod?.qty) > 0 &&
                                                                    <Box><InventoryChip label={`${t('TREATMENT_PRODUCT.CARD.QUANTITY')}: ${numberFormat(prod.qty, 0, 0)}`} limit={prod.qty <= prod.minStock} className="ml-2 p-0" /></Box>
                                                                }
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </ProductCard>
                                            </ProductBox>
                                        )
                                    })
                                ) || (
                                        <Typography textAlign="center" width="100%" sx={{ color: colors.disabledGray, paddingTop: '48px' }}>{t('TREATMENT_PRODUCT.TITLE.EMPTY_MEDICINE')}</Typography>
                                    )}
                            </ProductItem>
                        </TabPanel>
                        <TabPanel value={activeTab} index={4}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px" marginTop="8px">
                                <Typography sx={{ color: colors.themeMainColor, fontWeight: 600 }}>{t('รายการวัสดุอุปกรณ์ (MAT)')}</Typography>
                                <Box width="100%" sx={{ maxWidth: 379 }}>
                                    <TextInput
                                        label={t('ค้นหา รหัส / ชื่อวัสดุอุปกรณ์')}
                                        value={searchProduct}
                                        onChange={(event) => {
                                            setSearchProduct(event.target.value)
                                            debouncedLoadProduct(event.target.value, 'MATERIAL')
                                        }}
                                        fullWidth
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end" >
                                                    {!searchProduct ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                        <FontAwesomeIcon
                                                            icon={faTimes}
                                                            onClick={() => {
                                                                setSearchProduct('');
                                                                loadProduct('', "MATERIAL")
                                                            }}
                                                            style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                            <TypeTabs sx={{ display: 'flex', flexWrap: 'wrap' }} >
                                <Box paddingX="4px" paddingTop="8px" >
                                    <ButtonType variant="outlined" title={t('All')} className={`${typeSelected === 'ALL' || typeSelected === 0 ? 'active' : ''} overflow-hidden`} data-value={'All'} onClick={() => setTypeSelected('ALL')} key={`type-all`}>
                                        <span className="text-ellipsis">{t('All')}</span>
                                    </ButtonType>
                                </Box>
                                {_.map(productTypes, (type: any, index: number) => {
                                    if (type.group === 'MATERIAL') {
                                        return (
                                            <Box key={`med-type-${index}`} paddingX="4px" paddingTop="8px">
                                                <ButtonType variant="outlined" key={type.productTypeId} title={type.productTypeName || type.productTypeNameEn} onClick={() => setTypeSelected(type.productTypeId)} className={`${Number(typeSelected) === Number(type.productTypeId) ? 'active' : ''} text-ellipsis`}>
                                                    <span className="text-ellipsis">{type.productTypeName || type.productTypeNameEn}</span>
                                                </ButtonType>
                                            </Box>
                                        )
                                    }
                                })}
                            </TypeTabs>
                            <ProductItem display="flex" flexWrap="wrap" alignItems="start" marginTop="16px">
                                {!_.isEmpty(materials) && (
                                    _.map(materials, (prod: any, index: number) => {
                                        return (
                                            <ProductBox key={`prod-${index}`} sx={{
                                                px: '8px',
                                                mb: { xs: 2, xl: 3 },
                                                mt: '16px'
                                            }}>
                                                <ProductCard onClick={() => !disabledIsEdit() && onAdd(prod)} style={{ border: handleProductBorder(prod.itemId) ? `1px solid ${colors.themeSecondColor}` : '' }}>
                                                    <Box className='card-image' sx={(!prod?.img?.filePath || !prod?.img?.fileName) && { img: { objectFit: 'none !important' } } || {}}>
                                                        <Box className="position-relative">
                                                            {Number(prod?.qty) <= 0 && <span className='position-absolute top-50 start-50 translate-middle fw-bolder' style={{ fontSize: '22px', opacity: 0.9, zIndex: 1, borderBottom: '3px solid', paddingBottom: '' }}>{t('TREATMENT_PRODUCT.MATERIAL.OUT_STOCK')}</span> || <span></span>}
                                                            <img src={renderImage(prod?.img)} alt={prod.itemName} className={``} onError={onImgError} style={{ ...(Number(prod.qty) <= 0 && { opacity: 0.5 }) }} />
                                                        </Box>
                                                        {/* <Box position="relative">
                                                            {Number(prod?.qty) <= 0 && <span className='position-absolute top-50 start-50 translate-middle fw-bolder' style={{ fontSize: '20px', opacity: 0.9, zIndex: 1, borderBottom: '3px solid', paddingBottom: '' }}>{t('TREATMENT_PRODUCT.MEDICINE.OUT_STOCK')}</span> || <span></span>}
                                                            <img src={renderImage(prod?.img)} alt={prod.itemName} className={`${_.isEmpty(prod?.img) || !prod?.img?.filePath || !prod?.img?.fileName ? 'no-prod-image' : ''} `} width={renderImage(prod?.img) === icons.matDefault ? 12 : 1} onError={onImgError} style={{ ...(Number(prod.qty) <= 0 && { opacity: 0.5 }) }} />
                                                        </Box> */}
                                                    </Box>
                                                    <Box className='card-detail'>
                                                        <Typography fontSize={11} color="#707070">{prod?.itemCode}</Typography>
                                                        <Box display="flex" justifyContent="space-between" alignItems="start">
                                                            <Box overflow="hidden">
                                                                <Tooltip title={prod?.itemName} placement='top-start'><Typography className='text-ellipsis' sx={{ flex: 1 }}>{prod.itemName || '-'}</Typography></Tooltip>
                                                                <Typography className='text-ellipsis'>{numberFormat(prod.price || 0)} {t('CURRENCY_CHANGE.TH')}</Typography>
                                                            </Box>
                                                            <Box marginTop="4px" sx={{ display: 'block', textAlign: 'right' }}>
                                                                <Box>
                                                                    <AddIcon style={{ height: '24px', width: '24px', color: colors.white, backgroundColor: disabledIsEdit() ? colors.lightGray : colors.themeSecondColor, cursor: 'pointer', borderRadius: '4px' }} />
                                                                </Box>
                                                                {Number(prod?.qty) > 0 && <Box><InventoryChip label={`${t('TREATMENT_PRODUCT.CARD.QUANTITY')}: ${numberFormat(prod.qty, 0, 0)}`} limit={prod.qty <= prod.minStock} className="ml-2 p-0" /></Box>}
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </ProductCard>
                                            </ProductBox>
                                        )
                                    })
                                ) || (
                                        <Typography textAlign="center" width="100%" sx={{ color: colors.disabledGray, paddingTop: '48px' }}>{t('TREATMENT_PRODUCT.TITLE.EMPTY_MEDICINE')}</Typography>
                                    )}
                            </ProductItem>
                        </TabPanel>
                    </Box>

                    {activeTab === 0 &&
                        <Box>
                            <Typography marginY='16px' sx={{ color: colors.themeMainColor, fontWeight: 600 }}>
                                {t('TREATMENT_TEMPLATE.FORM.SUMMARY_DIAGNOSIS')}
                            </Typography>
                            <TableCustom
                                page={1}
                                pageLimit={0}
                                sortType={''}
                                sortBy={''}
                                onSort={() => { return }}
                                setPageLimit={() => { return }}
                                setPage={() => { return }}
                                rowCount={0}
                                headCells={headTableSummaryDiagnosis}
                                rowsData={_.map(summaryDiagnosisList, (val: any, i: any) => {
                                    return renderSummaryDiagnosis(val, i)
                                })}
                                // .reverse()
                                tableFixedWidth
                                tableMinWidth={1280}
                                hidePagination
                            />
                        </Box>
                    }

                    {activeTab !== 0 &&
                        <Box>
                            <Typography marginY='16px' sx={{ color: colors.themeMainColor, fontWeight: 600 }}>
                                {t('TREATMENT_TEMPLATE.FORM.SUMMARY_TEMPLATE')}
                                {/* <span style={{ color: colors.statusInactive }}>*</span> */}
                            </Typography>
                            <TableCustom
                                page={1}
                                pageLimit={0}
                                sortType={''}
                                sortBy={''}
                                onSort={() => { return }}
                                setPageLimit={() => { return }}
                                setPage={() => { return }}
                                rowCount={0}
                                headCells={headTableSummary}
                                rowsData={_.map(summaryTemplateList, (val: any, i: any) => {
                                    return renderSummary(val, i)
                                })}
                                // .reverse()
                                tableFixedWidth
                                tableMinWidth={1280}
                                hidePagination
                            />
                        </Box>
                    }
                    <Box height="54px" marginTop="8px" bgcolor="#F7F8F8" display="flex" justifyContent="end" alignItems="center" >
                        <Box display="flex" flexDirection="row" alignItems="center" gap="128px" marginRight="28px"  >
                            <Typography fontWeight={500} fontSize="18px">{t('TREATMENT_SUMMARY.TITLE.SUM_TOTAL')}</Typography>
                            <Typography fontWeight={500} fontSize="18px">{numberFormat(summaryTemplateList.map(({ amount, priceUnit }: any) => Number(amount) * Number(priceUnit)).reduce((a: any, b: any) => a + b, 0) || 0)} {t('CURRENCY_CHANGE.TH')}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

interface TabPanelProps {
    children?: React.ReactNode
    index: number | string
    value: number | string
    className?: string
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
        <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} className={'w-100 overflow-hidden'} {...other}>
            {value === index && <Box className="pl-md-3">{children}</Box>}
        </div>
    )
}

function a11yProps(index: number | string) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`
    }
}
